import React, {useRef, useState, useCallback} from 'react';
import {useNavigate} from 'react-router';

import * as paths from 'paths';
import {getCurrentUsername} from 'modules/authentication/utils';

import Trigger from './Trigger';
import Dropdown from './Dropdown';
import useClickOutside from './useClickOutside';

export default function ProfileMenu() {
    const navigate = useNavigate();
    const username = getCurrentUsername();
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    const close = useCallback(() => setOpen(false), []);
    useClickOutside(containerRef, close, open);

    const handleSignOut = () => {
        close();
        navigate(paths.LOGOUT_URL);
    };

    return (
        <div ref={containerRef} style={{position: 'relative'}}>
            <Trigger open={open} username={username} onToggle={() => setOpen(v => !v)}/>
            {open && <Dropdown username={username} onSignOut={handleSignOut}/>}
        </div>
    );
}
